import React from 'react';

import Auth from 'app/scripts/db/auth.coffee';
import PopOver from 'app/scripts/views/lib/pop-over.coffee';

import { forTemplate } from 'app/common/lib/util/i18n';
const format = forTemplate('dropbox_attachment');

import styles from './DropboxAttachment.less';
import { Icon, IconName } from 'app/common/components/controls';
import { AttachmentEditPopover } from './AttachmentEditPopover';
import { track } from '@trello/analytics';

const dropboxMarkSubtle = require('resources/images/dropbox-mark-subtle.svg');

interface Attachment {
  id: string;
  date: string;
  name: string;
  url: string;
}

interface DropboxAttachmentProps {
  attachment: Attachment;
  onRemoveAttachment: (idAttachment: string) => void;
}

export const DropboxAttachment: React.FunctionComponent<DropboxAttachmentProps> = ({
  attachment,
  onRemoveAttachment,
}) => {
  const dateAdded = new Date(attachment.date);
  // an empty string is bad, but undefined will make it fall back to browser locale
  const locale = Auth.myLocale() || undefined;
  const longDate = dateAdded.toLocaleString(locale, {
    // @ts-ignore it doesn't know that dateStyle is a real thing
    dateStyle: 'long',
    timeStyle: 'medium',
  });
  const shortDate = dateAdded.toLocaleString(locale, {
    month: 'short',
    day: 'numeric',
  });

  const openLink = (e: React.MouseEvent) => {
    e.preventDefault();
    window.open(attachment.url, attachment.url, 'noopener,noreferrer');
    track('Attachment', 'Open Link');
  };

  const editAttachment = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    PopOver.toggle({
      elem: e.target,
      getViewTitle: () => format('edit-attachment'),
      reactElement: AttachmentEditPopover({
        onRemoveAttachment: () => {
          track('Attachment', 'Delete Attachment', 'Dropbox');
          onRemoveAttachment(attachment.id);
        },
      }),
    });
  };

  return (
    <div role="button" className={styles.attachmentCard} onClick={openLink}>
      <a
        className={styles.attachmentCover}
        href={attachment.url}
        target="_blank"
        title={attachment.name}
        rel="noreferrer nofollow noopener"
      >
        <img
          src={dropboxMarkSubtle}
          height="40"
          width="40"
          alt={format('dropbox')}
        />
      </a>
      <div className={styles.attachmentDetail}>
        <div>
          <span className={styles.attachmentTitle}>{attachment.name}</span>
          <div className={styles.attachmentMeta}>
            <span>{format('dropbox')}</span>
            <span className={styles.metaSeparator}> • </span>
            <span title={longDate}>{shortDate}</span>
          </div>
        </div>
        <a
          className={styles.attachmentMenu}
          onClick={editAttachment}
          role="button"
        >
          <Icon name={IconName.OverflowMenuHorizontal} />
        </a>
      </div>
    </div>
  );
};
